<template>
  <div>

    <z-centralized-toolbar>  
      <v-toolbar-items>
        <v-btn
          id="btn-adicionar"
          text
          small
          color="primary"
          :disabled="!$auth.temPermissao('categorias_cadastrar')"
          @click="adicionar"
        >
          <v-icon left>mdi-plus</v-icon>Adicionar
        </v-btn>
        <v-btn
          id="btAtualizar"
          text
          small
          :loading="$store.state.loading"
          @click="refresh"
        >
          <v-icon>refresh</v-icon>
          <v-tooltip bottom activator="#btAtualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
      </v-toolbar-items>

      <div style="width: 300px;" class="ml-5">
        <v-text-field
          rounded
          outlined
          single-line
          dense
          label="Pesquisar"
          autofocus
          clearable
          hide-details
          prepend-inner-icon="search"
          v-model="search"
          @keydown.enter="refresh"
          @click:clear="limparBusca"
        ></v-text-field>
      </div>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Categorias</h3>
      
      <v-card>
        <v-data-table
          :headers="headers"
          :items="categorias"
          item-key="id"
          :loading="false"
          :search="search"
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
          disable-sort
        >
          <template v-slot:item="{ item: categoria }">
            <tr>
              <td>{{ categoria.descricao }}</td>
              <td>
                <!-- <v-chip close>text</v-chip> -->
                <v-icon :color="categoria.cor">mdi-circle</v-icon>
                <!-- <v-chip small :color="categoria.cor_primaria">{{categoria.cor_primaria}}</v-chip> -->
              </td>
              <td class="text-center">
                <v-btn title="Editar" icon @click="editar(categoria)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <!-- <v-btn title="Excluir" icon @click="perguntarExcluir(categoria)">
                  <v-icon>delete</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo-sim-nao
      ref="dialogoRemoverLoja"
      titulo="Remover categoria?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      O categoria <b>{{ categoria.nome }}</b> será removida.
    </z-dialogo-sim-nao>

    <categorias-form ref="dialogoCategoriasForm"></categorias-form>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import CategoriasForm from "./CategoriasForm";
export default {
  name: "CategoriasLista",
  components: {
    CategoriasForm,
  },

  data() {
    return {
      // globals,
      headers: [
        { text: "Descrição", value: "descricao" },
        { text: "Cor", value: "cor_primaria", width: "100px" },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false },
      ],
      excluindo: false,
      categoria: {},
    };
  },

  computed: {
    ...mapState("categoriascontas", ["categorias", "pagination", "total_de_registros"]),

    search: {
      get() {
        return this.$store.state.categoriascontas.search;
      },
      set(search) {
        this.$store.commit("categoriascontas/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.categoriascontas.pagination;
      },
      set(options) {
        this.$store.commit("categoriascontas/UPDATE_PAGINATION", options);
      },
    },
  },

  created() {
    this.setTitulo("Categorias Contas a Pagar");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("categoriascontas", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erroSistema("Não foi possível obter a lista de categorias.");
        throw error;
      } finally {
        this.$store.commit("LOADING_OFF");
      }
    },

    adicionar() {
      this.$store.commit("categoriascontas/ZERAR");
      this.$refs.dialogoCategoriasForm.abrir();
    },

    async editar(categoria) {
      try {
        await this.abrir(categoria.id);
        this.$refs.dialogoCategoriasForm.abrir();
      } catch (error) {
        this.$eventbus.notificar("Não foi possível editar o categoria.");
      } finally {
        this.LOADING_OFF();
      }
    },

    perguntarExcluir(categoria) {
      this.categoria = categoria;
      this.$refs.dialogoRemoverLoja.abrir().then(async (response) => {
        if (response == true) {
          await this.confirmarExcluir();
        }
      });
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.categoria.id);
        this.$refs.dialogoRemoverLoja.fechar();
        this.$eventbus.notificar("Lote excluído com sucesso!");
      } catch (error) {
        if (error.response) {
          this.$eventbus.erroSistema(error?.response?.data?.message);
        } else {
          this.$eventbus.erroSistema("Não foi possível excluir categoria!");
        }
      } finally {
        this.excluindo = false;
      }
    },

    limparBusca() {
      this.search = "";
      this.$store.commit("categoriascontas/SET_PAGE", 1);
      this.refresh();
    },
  },



  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
